module.exports = __webpack_public_path__ + "eb4226b4c970ee66cc247fa697fab7bb.svg";